/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllReferralCareAttributes200ResponseDataInner } from './FindAllReferralCareAttributes200ResponseDataInner';
import {
    FindAllReferralCareAttributes200ResponseDataInnerFromJSON,
    FindAllReferralCareAttributes200ResponseDataInnerFromJSONTyped,
    FindAllReferralCareAttributes200ResponseDataInnerToJSON,
    FindAllReferralCareAttributes200ResponseDataInnerToJSONTyped,
} from './FindAllReferralCareAttributes200ResponseDataInner';

/**
 * 
 * @export
 * @interface FindAllReferralCareAttributes200Response
 */
export interface FindAllReferralCareAttributes200Response {
    /**
     * 
     */
    data?: Array<FindAllReferralCareAttributes200ResponseDataInner>;
}

/**
 * Check if a given object implements the FindAllReferralCareAttributes200Response interface.
 */
export function instanceOfFindAllReferralCareAttributes200Response(value: object): value is FindAllReferralCareAttributes200Response {
    return true;
}

export function FindAllReferralCareAttributes200ResponseFromJSON(json: any): FindAllReferralCareAttributes200Response {
    return FindAllReferralCareAttributes200ResponseFromJSONTyped(json, false);
}

export function FindAllReferralCareAttributes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllReferralCareAttributes200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(FindAllReferralCareAttributes200ResponseDataInnerFromJSON)),
    };
}

export function FindAllReferralCareAttributes200ResponseToJSON(json: any): FindAllReferralCareAttributes200Response {
    return FindAllReferralCareAttributes200ResponseToJSONTyped(json, false);
}

export function FindAllReferralCareAttributes200ResponseToJSONTyped(value?: FindAllReferralCareAttributes200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(FindAllReferralCareAttributes200ResponseDataInnerToJSON)),
    };
}

